<template>
    <div>
        <slot />
    </div>
</template>

<script>
import TouchMixin from "~/mixins/TouchMixin";

export default {
    
    mixins: [TouchMixin],

    props: {
        active: {
            type: Boolean,
            default: false
        }
    },

    data() {
        return {
            isInitialized: false
        }
    },

    mounted() {
        
        if (this.active) {
            this.initialize();
        }

        if ('swipeLeft' in this.$listeners) {
            this.touchBindSwipeLeft(this.$listeners['swipeLeft']);
        }

        if ('swipeRight' in this.$listeners) {
            this.touchBindSwipeRight(this.$listeners['swipeRight']);
        }
    },

    watch: {
        active() {
            if (this.active && !this.isInitialized) {
                this.initialize();
            }
        }
    },

    methods: {
        initialize() {
            
            this.touchInitialize();
            
            this.isInitialized = true;
        }
    }
}
</script>